export default "__VITE_ASSET__4199e335__"